import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { InjectionProfile } from '../../fulfillmentContext/types';

export interface InjectionProfilesModel {
  injectionProfilesMap: Record<string, InjectionProfile>;
  setInjectionProfiles: Action<InjectionProfilesModel, InjectionProfile[]>;
  setInjectionProfile: Action<InjectionProfilesModel, InjectionProfile>;
  fetchInjectionProfilesLoading: boolean;
  setFetchInjectionProfilesLoading: Action<InjectionProfilesModel, boolean>;
  fetchInjectionProfiles: Thunk<InjectionProfilesModel, void, Injections, StoreModel, Promise<void>>;
  fetchInjectionProfilesFailure: Action<InjectionProfilesModel, ApplicationErrorOptions>;
}

export const injectionProfilesModel: InjectionProfilesModel = {
  injectionProfilesMap: {},
  setInjectionProfiles: action((state, injectionProfiles) => {
    const injectionProfilesMap = injectionProfiles.reduce<Record<string, InjectionProfile>>((acc, curr) => {
      acc[curr.injectionProfileId] = curr;
      return acc;
    }, {});
    state.injectionProfilesMap = injectionProfilesMap;
  }),
  setInjectionProfile: action((state, injectionProfile) => {
    state.injectionProfilesMap[injectionProfile.injectionProfileId] = injectionProfile;
  }),
  fetchInjectionProfilesLoading: false,
  setFetchInjectionProfilesLoading: action((state, isLoading) => {
    state.fetchInjectionProfilesLoading = isLoading;
  }),
  fetchInjectionProfiles: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchInjectionProfilesLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchInjectionProfiles();
      actions.setInjectionProfiles(response);
      actions.setFetchInjectionProfilesLoading(false);
      return response;
    } catch (error) {
      actions.fetchInjectionProfilesFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchInjectionProfilesLoading(false);
      return error;
    }
  }),
  fetchInjectionProfilesFailure: action((state, error) => {
    console.error(error);
  }),
};

export default injectionProfilesModel;
